function setWWDOLocalStorage (jobData) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 7);
  localStorage.setItem("wwdo-expiration", expirationDate);
  localStorage.setItem("wwdo-job", JSON.stringify(jobData));
}

export default setWWDOLocalStorage;